<template>
    <v-container class="v-container--max-width">
        <Banner
                type="warning"
                icon="mdi-information"
                title="Informativo"
                class="d-flex w-100"
                :max-width="false"
        >
            É possível acessar a proposta <strong>individualmente</strong> ao <strong>clicar no número dela.</strong>
            <br>
            As cotas só são <strong>exibidas após a alocação.</strong>
        </Banner>
        <v-card class="mx-auto" elevation="2">
            <v-row class="px-3 pt-5">
                <v-col cols="12" md="3" class="d-flex justify-center order-3 order-md-1 justify-md-start my-4 my-md-1 align-center">
                    <FilterToggleButton class="ml-1" v-model="filter_open" />
                </v-col>
                <v-col cols="12" md="6" class="d-flex order-2 justify-center align-center">
                    <h2 class="primary--text text-center">SITUAÇÃO DE PAGAMENTO/CONTRATOS</h2>
                </v-col>
                <v-col cols="12" md="3" class="d-flex order-2 order-md-3 justify-center justify-md-end">
                    <div class="mt-2 mr-1">
                        <v-btn color="primary" @click="voltarAoMinhasVendas">
                            <v-icon class="mr-1" size="16">
                                mdi-file-document
                            </v-icon>
                            <span>Minhas Vendas</span>
                        </v-btn>
                    </div>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <FiltroMultiplaCotas v-show="filter_open" v-model="filters" @input="limparSelecao" />
                </v-col>
            </v-row>
            <v-card-text>
                <div class="table-container">
                    <v-data-table
                            :headers="headers"
                            :items="filteredPropostas"
                            item-key="id_pedido"
                            class=" custom-table"
                            sort-by="id_documento"
                            fixed-header
                            :items-per-page="10"
                            :sort-desc="true"
                            :items-per-page-options="[10, 20, 50]"
                    >
                        <template #header.select="{ props }">
                            <v-checkbox
                                    hide-details
                                    dark
                                    class="ml-2 mr-n1"
                                    :input-value="allSelected"
                                    :indeterminate="someSelected"
                                    @change="toggleSelectAll"
                            />
                        </template>
                        <template v-slot:item="{item}">
                            <tr>
                                <td style="padding:0px 0px;">
                                    <v-checkbox
                                            class="ml-6 mr-n1"
                                            color="accent"
                                            :input-value="isSelected(item.id_pedido)"
                                            @change="val => toggleOne(item.id_pedido,val)"
                                            hide-details />
                                </td>
                                <td style="max-width: 120px" class="td-item bordered-cell bordered-cell-left">
                                    <template v-if="item.id_documento">
                                        <v-tooltip right>
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="primary" v-on="on" tile elevation="0"
                                                       style="border:none;width: 100%" :outlined="false"
                                                       @click="irParaDetalhes(item)" text>
                                                    <span class="text-id-documento">
                                                        {{ item.id_documento }}
                                                    </span>
                                                </v-btn>
                                            </template>
                                            <span>
                                                Ao clicar no número da proposta, você será redirecionado para
                                                a tela de detalhes da proposta em questão.
                                            </span>
                                        </v-tooltip>
                                    </template>
                                    <template v-else>
                                        <div style="border:none;width: 100%;height: 48px; align-content: center; text-align: center;" :outlined="false">
                                            <span color="primary" class="text-id-documento-not-generate">Não gerada</span>
                                        </div>
                                    </template>
                                </td>
                                <td
                                        class="td-item bordered-cell"
                                >
                                    {{ item.grupo_cota }}
                                </td>
                                <td
                                        class="td-item bordered-cell" style="text-transform: none;"
                                >
                                    {{ item.forma_pagamento_formatada }}
                                </td>
                                <td
                                        class="td-item bordered-cell"
                                        :style="{
                                            backgroundColor: getBackgroundColorStatusBoleto(
                                                item.status_boleto
                                            ),
                                        }"
                                >
                                    {{ item.status_boleto }}
                                </td>
                                <td
                                        class="td-item bordered-cell"
                                        :style="{
                                            backgroundColor: getBackgroundColorStatusContrato(
                                                item.status_contrato
                                            ),
                                        }"
                                >
                                    {{ item.status_contrato }}
                                </td>
                                <td class="td-item bordered-cell">
                                    <div class="d-flex justify-center">
                                        <botao-acao
                                                @retentarGeracaoProposta="retentarGeracaoProposta(item.id_pedido, item.cliente && item.cliente.email)"
                                                @reenviarContrato="reenviarContrato(item.contrato && item.contrato.id_contrato, item.whatsapp, exibe_reenvio_whatsapp,false)"
                                                @reenviarBoleto="enviarBoletoProposta(item.id_pedido, item.cliente && item.cliente.email)"
                                                @reenviaLink="reenviaLink(item.id_pedido, item.cliente && item.cliente.email)"
                                                @retentarAlocacao="retentarAlocacao(item.id_pedido)"
                                                :id-documento="item.id_documento"
                                                :status-pedido="item.status_pedido"
                                                :contrato="item.contrato"
                                                :status-boleto="item.status_boleto"
                                                :forma-pagamento="item.forma_pagamento"
                                                :job-carrinho-boleto-agendado="item.job_carrinho_boleto_agendado"
                                        />
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </div>
            </v-card-text>
        </v-card>
        <v-card class="mt-3 mx-auto py-0 px-0" elevation="2" style="max-width: 90%;width: fit-content;">
            <v-card-text class="px-0 py-0 pl-1" style="border-radius: 12px;">
                <IlhaAcoesMultiplas
                        @reenviarContrato="reenviarContrato"
                        @reenviarBoleto="enviarBoletoProposta"
                        @atualizaTela="onAtualizaTela"
                        :selected-items="selectedPropostas" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { mapState } from 'vuex'
  import { getDescricaoStatusContrato } from '@/plugins/helpers'
  import { FormasPagamento, StatusPedidoDesc } from '../plugins/constants'
  import { existHierarchy, notification, verifyIfPaidAndReturnInBool } from '../plugins/helpers'
  import { getStatusBoleto } from '../plugins/multiplasCotasBoletoStatus'
  import { estilosStatusAlocacaoPorNomeExibicao, estilosStatusBoletoCarrinhoPorNomeExibicao, estilosStatusContratoPorNomeExibicao } from '../plugins/listaEstilosPorStatusPorNomeExibicao'
  import BotaoAcao from '../components/carrinho/detalhes-multiplas-reservas/BotaoAcao.vue'
  import { AlertTypes } from '../plugins/alerts_types'
  import realizarVendaMixin from '../mixins/realizarVendaMixin'
  import enviarBoletoMixin from '../mixins/enviarBoletoMixin'
  import reenviarContratoMixin from '@/mixins/reenviarContratoMixin'
  import checarAlocacaoMixin from '../mixins/checarAlocacaoMixin'
  import BotoesPropostaMixin from '../mixins/BotoesPropostaMixin'
  import store from '../store'
  import Banner from '../components/common/Banner.vue'
  import FiltroMultiplaCotas from '../components/carrinho/detalhes-multiplas-cotas/FiltroMultiplaCotas.vue'
  import FilterToggleButton from '../components/buttons/FilterToggleButton.vue'
  import { StatusAlocacoes } from '../plugins/status_alocacoes'
  import IlhaAcoesMultiplas from '../components/carrinho/detalhes-multiplas-cotas/IlhaAcoesMultiplas.vue'
  import { permiteReenviarBoleto, permiteReenviarContrato, permiteRetentarGeracaoProposta } from '../helpers/validacao_acoes_carrinho'
  import { PollingService } from '@/helpers/polling'
  import { verificarAtualizacoesPropostas } from '@/webservice/propostas'

  export default {
    name: 'DetalhesVendaMultipla',
    components: { IlhaAcoesMultiplas, FilterToggleButton, FiltroMultiplaCotas, BotaoAcao, Banner },
    mixins: [realizarVendaMixin, enviarBoletoMixin, reenviarContratoMixin, checarAlocacaoMixin, BotoesPropostaMixin],
    data () {
      return {
        filter_open: false,
        requestIdentifier: 0,
        propostas: [],
        idsPedidoPropostasSelecionadas: [],
        filters: {
          numero: '',
          statusPagamento: null,
          statusContrato: null,
          formaPagamento: null
        },
        headers: [
          { text: 'select', sortable: false, name: 'select', value: 'select', width: '30px' },
          { text: 'Proposta', value: 'id_documento', width: '150px' },
          { text: 'Grupo/Cota', value: 'grupo_cota' },
          { text: 'Forma de Pagamento', value: 'forma_pagamento_formatada' },
          { text: 'Status do Pagamento', value: 'status_boleto' },
          { text: 'Status do Contrato', value: 'status_contrato' },
          { text: 'Ações', sortable: false, align: 'center' }
        ],
        pollingPropostas: null,
        hashPropostas: null,
        vendaRecentementeCriada: false,
        _visibilityChangeHandler: null
      }
    },
    computed: {
      ...mapState(['id_comissionado_venda', 'hierarquia_comercial', 'exibe_reenvio_whatsapp']),
      allSelected () {
        const vis = this.filteredPropostas
        return vis.length > 0 && vis.every(i => this.idsPedidoPropostasSelecionadas.includes(i.id_pedido))
      },
      someSelected () {
        const vis = this.filteredPropostas
        const cnt = vis.filter(i => this.idsPedidoPropostasSelecionadas.includes(i.id_pedido)).length
        return cnt > 0 && cnt < vis.length
      },
      filteredPropostas () {
        return this.propostas.filter(item => {
          if (
            this.filters.numero &&
            !String(item.id_documento || '')
              .toLowerCase()
              .includes(this.filters.numero.toLowerCase())
          ) {
            return false
          }
          if (
            this.filters.statusPagamento &&
            item.status_boleto !== this.filters.statusPagamento
          ) {
            return false
          }
          if (
            this.filters.statusContrato &&
            item.status_contrato !== this.filters.statusContrato
          ) {
            return false
          }
          if (
            this.filters.formaPagamento &&
            item.forma_pagamento_formatada !== this.filters.formaPagamento
          ) {
            return false
          }
          return true
        })
      },
      selectedPropostas () {
        return this.propostas.filter(proposta => this.idsPedidoPropostasSelecionadas.includes(proposta.id_pedido))
      }
    },
    async mounted () {
      await this.fetchPropostas()

      this.iniciarPollingPropostas()

      this._visibilityChangeHandler = () => this.handleVisibilityChangePropostas()
      document.addEventListener('visibilitychange', this._visibilityChangeHandler)
    },
    beforeDestroy () {
      if (this._visibilityChangeHandler) {
        document.removeEventListener('visibilitychange', this._visibilityChangeHandler)
        this._visibilityChangeHandler = null
      }

      this.pararPollingPropostas()
    },
    methods: {
      formatFormaPagamento (forma) {
        switch (forma) {
          case FormasPagamento.Boleto:
            return 'Boleto'
          case FormasPagamento.Cartao:
            return 'Cartão'
          case FormasPagamento.Link:
            return 'Link de Pagamento'
          default:
            return forma || 'Não definida'
        }
      },
      limparSelecao () {
        this.idsPedidoPropostasSelecionadas = []
      },
      setVendasSelecionadas (vendas) {
        this.selected = vendas
      },
      async onAtualizaTela () {
        await this.fetchPropostas()
      },
      formatGroupCota (cd_cota, cd_grupo, status_alocacao) {
        const alocada = status_alocacao === StatusAlocacoes.Alocado
        if (alocada && cd_cota) {
          return `${cd_grupo}/${cd_cota}`
        }
        if (cd_grupo) {
          return cd_grupo + '/-'
        }
        return '-'
      },
      async fetchPropostas ({ silent = false } = {}) {
        this.requestIdentifier = this.requestIdentifier + 1
        const requestId = 'fetchDataRequest' + this.requestIdentifier
        if (this.requestIdentifier > 1) {
          this.$http.cancel('fetchDataRequest' + (this.requestIdentifier - 1))
        }

        this.pausarMonitoramento = true
        if (!silent) {
          store.commit('loadingStart')
        }

        try {
          const response = await this.$http.get(`/vendas/${this.$route.params.id_pedido}`, {
            requestId: requestId
          })

          if (!response || !response.data) {
            return
          }

          if (response.data.id_comissionado !== this.id_comissionado_venda && !existHierarchy(this.hierarquia_comercial)) {
            return this.$router.push({ name: 'minhas-vendas' })
          }
          this.propostas = response.data.carrinho.pedidos.map(pedido => {
            const boletoPago = verifyIfPaidAndReturnInBool(pedido.status_pedido)

            return {
              id_documento: pedido.id_documento,
              id_pedido: pedido.id_pedido,
              id_carrinho: pedido.id_carrinho,
              forma_pagamento: pedido.forma_pagamento,
              forma_pagamento_formatada: this.formatFormaPagamento(pedido.forma_pagamento),
              status_pedido_desc: StatusPedidoDesc[pedido.status_pedido],
              status_pedido: pedido.status_pedido,
              status_boleto: this.getStatusBoleto(!!pedido.job_carrinho_boleto_sucesso, !!pedido.job_carrinho_boleto_falha, !!pedido.job_carrinho_boleto_agendado, !!boletoPago, pedido.forma_pagamento),
              status_contrato: getDescricaoStatusContrato(pedido.contrato && pedido.contrato.status, pedido.docusign_falha, pedido.docusign_enviado),
              whatsapp: pedido.whatsapp,
              contrato: pedido.contrato,
              cliente: pedido.cliente,
              grupo_cota: this.formatGroupCota(pedido.cd_cota, pedido.cd_grupo, pedido.status_alocacao && pedido.status_alocacao.status_alocacao),
              updated_at: pedido.updated_at
            }
          })
          setTimeout(() => {
            this.propostasMonitoradas = [...this.propostas]
            this.pausarMonitoramento = false
          }, 1000)
        } catch (error) {
          console.error('Erro ao buscar propostas:', error)
          if (error.message !== 'Request canceled') {
            // 🔍 Extrai mensagem de erro do backend se disponível
            const msgErro = error?.response?.data?.Msg_Erro || error?.message || 'Erro ao carregar propostas'
            notification(AlertTypes.ERROR, msgErro)
          }
        } finally {
          if (!silent) {
            store.commit('loadingDone')
          }
        }
      },
      getDescricaoStatusContrato,
      getStatusBoleto,
      getBackgroundColorStatusContrato (status) {
        return estilosStatusContratoPorNomeExibicao[status].colorPastel ?? '#fff'
      },
      getBackgroundColorStatusAlocacao (status) {
        return estilosStatusAlocacaoPorNomeExibicao[status].colorPastel ?? '#fff'
      },
      getBackgroundColorStatusBoleto (status) {
        return estilosStatusBoletoCarrinhoPorNomeExibicao[status].colorPastel ?? '#fff'
      },
      irParaDetalhes (venda) {
        this.$session.set('id_pedido_detalhes_venda', venda.id_pedido)
        this.$router.replace({ name: 'detalhes-venda' })
      },
      getAcoesPedido (pedido) {
        const acoes = []
        if (permiteRetentarGeracaoProposta(pedido.id_documento, pedido.status_pedido)) {
          acoes.push({ titulo: 'Retentar geração da proposta', nomeFuncao: 'retentarGeracaoProposta' })
        }
        if (permiteReenviarContrato(pedido.contrato)) {
          acoes.push({ titulo: 'Reenviar o contrato', nomeFuncao: 'reenviarContrato' })
        }
        if (permiteReenviarBoleto(pedido.status_boleto, pedido.forma_pagamento)) {
          acoes.push({ titulo: 'Reenviar o boleto', nomeFuncao: 'reenviarBoleto' })
        }
        if (pedido.forma_pagamento === FormasPagamento.Link) {
          acoes.push({ titulo: 'Reenviar o link de pagamento', nomeFuncao: 'reenviaLink' })
        }

        return acoes
      },
      async retentarGeracaoProposta (id_pedido, email) {
        try {
          if (!email) {
            notification(AlertTypes.ERROR, 'O cliente não possui email cadastrado, corrija e tente novamente.')
            return
          }
          const res_venda = await this.realizarVenda(id_pedido, FormasPagamento.Boleto, null, false, true)

          await this.enviarBoleto(id_pedido, email, true)
          const msg_pagamento = 'Venda enviada com sucesso! O cliente receberá um novo e-mail com o boleto da proposta separadamente.'
          const detalhes = res_venda.msg ? ('\n' + res_venda.msg) : ''

          // 🔒 Marcar que acabamos de criar uma venda para evitar notificação duplicada do polling
          this.vendaRecentementeCriada = true
          setTimeout(() => {
            this.vendaRecentementeCriada = false
          }, 15000) // 15 segundos para o polling detectar a nova proposta

          await this.fetchPropostas()
          if (res_venda.enviado) {
            notification(AlertTypes.SUCCESS, `Venda enviada com sucesso!${detalhes}`)
          }

          if (msg_pagamento) {
            notification(AlertTypes.INFO, msg_pagamento)
          }
        } catch (err) {
          // 🔍 Extrai mensagem de erro do Newcon se disponível
          const msgErro = err?.response?.data?.Msg_Erro || err?.message || 'Erro ao processar a venda'
          notification(AlertTypes.ERROR, msgErro)
          await this.fetchPropostas()
        }
      },
      async reenviarContrato (id_contrato, whatsapp, exibe_reenvio_whatsapp, multiplas_cotas) {
        this.showDialogReenviaContrato(id_contrato, whatsapp, exibe_reenvio_whatsapp, multiplas_cotas)
      },
      async enviarBoletoProposta (pedido, email) {
        const response = await this.enviarBoleto(pedido, email, true, true)
        await this.fetchPropostas()
        if (response.data.msgStack) {
          for (let mensagem of response.data.msgStack) {
            notification(mensagem.type, mensagem.message, '')
          }
        }
      },
      async reenviaLink (id_pedido, email) {
        try {
          await this.$http.post('/proposta/linkpagamento/reenviar', { id_pedido, email })
          notification(AlertTypes.SUCCESS, 'Link de pagamento reenviado com sucesso!')
          await this.fetchPropostas()
        } catch (error) {
          // 🔍 Extrai mensagem de erro do backend se disponível
          const msgErro = error?.response?.data?.Msg_Erro || error?.message || 'Erro ao reenviar o link de pagamento'
          notification(AlertTypes.ERROR, msgErro)
        }
      },
      async retentarAlocacao (id_pedido) {
        this.checarAlocacaoCota(id_pedido)
      },
      isSelected (id) {
        return this.idsPedidoPropostasSelecionadas.includes(id)
      },
      toggleOne (id, checked) {
        const idx = this.idsPedidoPropostasSelecionadas.indexOf(id)
        if (checked && idx === -1) this.idsPedidoPropostasSelecionadas.push(id)
        if (!checked && idx !== -1) this.idsPedidoPropostasSelecionadas.splice(idx, 1)
      },
      toggleSelectAll (checked) {
        if (checked) {
          this.filteredPropostas.forEach(i => {
            if (!this.idsPedidoPropostasSelecionadas.includes(i.id_pedido)) {
              this.idsPedidoPropostasSelecionadas.push(i.id_pedido)
            }
          })
        } else {
          this.filteredPropostas.forEach(i => {
            const idx = this.idsPedidoPropostasSelecionadas.indexOf(i.id_pedido)
            if (idx !== -1) this.idsPedidoPropostasSelecionadas.splice(idx, 1)
          })
        }
      },
      voltarAoMinhasVendas () {
        this.$router.push({ name: 'minhas-vendas' })
      },
      iniciarPollingPropostas () {
        if (this.pollingPropostas) {
          return
        }

        this.pollingPropostas = new PollingService(
          this.verificarAtualizacoesPropostas,
          10000,
          {
            debug: localStorage.getItem('DEBUG_POLLING') === 'true',
            maxRetries: 3,
            initialBackoff: 1000,
            maxBackoff: 4000,
            name: 'polling-propostas-detalhes',
            adaptivePolling: false,
            minInterval: 10000,
            maxInterval: 10000,
            onError: (error) => {
              console.error('[DetalhesVendaMultipla] Erro no polling:', error)
            },
            onSuccess: () => {}
          }
        )

        this.pollingPropostas.start()
      },
      async verificarAtualizacoesPropostas () {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        try {
          const id_pedido = this.$route.params.id_pedido

          if (!id_pedido) {
            throw new Error('ID do pedido não encontrado na rota')
          }

          const resultado = await verificarAtualizacoesPropostas({
            id_comissionado: this.id_comissionado_venda,
            id_pedido: parseInt(id_pedido),
            ultimo_hash: this.hashPropostas
          })

          if (debugPolling) {
            console.log('📡 [verificarAtualizacoesPropostas] Resposta recebida:', {
              tem_atualizacao: resultado.data.tem_atualizacao,
              hash_anterior: this.hashPropostas,
              hash_atual: resultado.data.hash_atual,
              quantidade_propostas_backend: resultado.data.quantidade_propostas,
              quantidade_propostas_locais: this.propostas.length
            })
          }

          this.hashPropostas = resultado.data.hash_atual

          if (resultado.data.tem_atualizacao) {
            if (debugPolling) {
              console.log('🔄 [verificarAtualizacoesPropostas] Atualizações detectadas! Processando...')
            }

            const propostasAntigas = [...this.propostas]

            await this.fetchPropostas({ silent: true })

            this.detectarENotificarMudancasPropostas(propostasAntigas, this.propostas)
          }
        } catch (error) {
          throw error
        }
      },
      detectarENotificarMudancasPropostas (propostasAntigas, propostasNovas) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (!propostasAntigas || propostasAntigas.length === 0) {
          return
        }

        const hashAntigo = JSON.stringify(propostasAntigas.map(p => ({
          id: p.id_pedido,
          status_pedido: p.status_pedido,
          status_boleto: p.status_boleto,
          status_contrato: p.status_contrato,
          grupo_cota: p.grupo_cota,
          updated_at: p.updated_at
        })))

        const hashNovo = JSON.stringify(propostasNovas.map(p => ({
          id: p.id_pedido,
          status_pedido: p.status_pedido,
          status_boleto: p.status_boleto,
          status_contrato: p.status_contrato,
          grupo_cota: p.grupo_cota,
          updated_at: p.updated_at
        })))

        if (hashAntigo === hashNovo) {
          if (debugPolling) {
            console.log('⏭️ [detectarMudancasPropostas] Dados idênticos - sem mudanças')
          }
          return
        }

        if (debugPolling) {
          console.log('🔍 [detectarMudancasPropostas] Comparando propostas:', {
            quantidadeAnterior: propostasAntigas.length,
            quantidadeAtual: propostasNovas.length
          })
        }

        const propostasModificadas = []
        const propostasAdicionadas = []
        const propostasRemovidas = []

        propostasNovas.forEach(propNova => {
          const propAntiga = propostasAntigas.find(p => p.id_pedido === propNova.id_pedido)

          if (!propAntiga) {
            propostasAdicionadas.push(propNova)
          } else {
            const houveAlteracao =
              propAntiga.status_pedido !== propNova.status_pedido ||
              propAntiga.status_boleto !== propNova.status_boleto ||
              propAntiga.status_contrato !== propNova.status_contrato ||
              propAntiga.grupo_cota !== propNova.grupo_cota

            if (houveAlteracao) {
              propostasModificadas.push({
                proposta: propNova,
                mudancas: {
                  status_pedido: propAntiga.status_pedido !== propNova.status_pedido,
                  status_boleto: propAntiga.status_boleto !== propNova.status_boleto,
                  status_contrato: propAntiga.status_contrato !== propNova.status_contrato,
                  grupo_cota: propAntiga.grupo_cota !== propNova.grupo_cota
                }
              })
            }
          }
        })

        propostasAntigas.forEach(propAntiga => {
          const existe = propostasNovas.find(p => p.id_pedido === propAntiga.id_pedido)
          if (!existe) {
            propostasRemovidas.push(propAntiga)
          }
        })

        if (debugPolling) {
          console.log('🔄 [detectarMudancasPropostas] Mudanças detectadas:', {
            modificadas: propostasModificadas.length,
            adicionadas: propostasAdicionadas.length,
            removidas: propostasRemovidas.length
          })
        }

        if (propostasModificadas.length > 0) {
          this.notificarPropostasModificadas(propostasModificadas)
        } else if (propostasAdicionadas.length > 0) {
          this.notificarPropostasAdicionadas(propostasAdicionadas)
        } else if (propostasRemovidas.length > 0) {
          this.notificarPropostasRemovidas(propostasRemovidas)
        }
      },
      notificarPropostasModificadas (propostasModificadas) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (propostasModificadas.length === 0) return

        // 🔒 FILTRAR: Apenas propostas com id_documento gerado
        // Evita notificações duplicadas quando id_documento ainda não foi gerado
        const propostasComDocumento = propostasModificadas.filter(item => {
          const proposta = item.proposta
          return proposta.id_documento != null && proposta.id_documento !== ''
        })

        if (propostasComDocumento.length === 0) {
          if (debugPolling) {
            console.log('⏭️ [notificar] Propostas modificadas sem id_documento - notificação suprimida:', {
              quantidade_filtrada: propostasModificadas.length,
              ids_pedido: propostasModificadas.map(m => m.proposta.id_pedido)
            })
          }
          return
        }

        if (propostasComDocumento.length === 1) {
          const { proposta, mudancas } = propostasComDocumento[0]

          let detalhe = ''
          if (mudancas.status_contrato) {
            detalhe = `Contrato: ${proposta.status_contrato}`
          } else if (mudancas.status_boleto) {
            detalhe = `Boleto: ${proposta.status_boleto}`
          } else if (mudancas.status_pedido) {
            detalhe = `Status: ${proposta.status_pedido_desc}`
          } else if (mudancas.grupo_cota) {
            detalhe = `Cota alocada: ${proposta.grupo_cota}`
          }

          const mensagem = `Proposta #${proposta.id_documento} foi atualizada. ${detalhe}`
          notification(AlertTypes.INFO, mensagem)

          if (debugPolling) {
            console.log('🔔 [notificar] Proposta única modificada:', {
              id_pedido: proposta.id_pedido,
              id_documento: proposta.id_documento,
              mudancas
            })
          }
        } else {
          const mensagem = `${propostasComDocumento.length} propostas foram atualizadas`
          notification(AlertTypes.INFO, mensagem)

          if (debugPolling) {
            console.log('🔔 [notificar] Múltiplas propostas modificadas:', {
              quantidade: propostasComDocumento.length,
              ids_documento: propostasComDocumento.map(m => m.proposta.id_documento)
            })
          }
        }
      },
      notificarPropostasAdicionadas (propostasAdicionadas) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        // 🔒 VALIDAÇÃO: Evitar notificação duplicada ao criar venda
        // Se acabamos de criar uma venda, não mostramos a notificação do polling
        if (this.vendaRecentementeCriada) {
          if (debugPolling) {
            console.log('⏭️ [notificar] Notificação de proposta adicionada suprimida (venda recém criada)')
          }
          return
        }

        // 🔒 FILTRAR: Apenas propostas com id_documento gerado
        // Evita notificações duplicadas quando id_documento ainda não foi gerado
        const propostasComDocumento = propostasAdicionadas.filter(proposta => {
          return proposta.id_documento != null && proposta.id_documento !== ''
        })

        if (propostasComDocumento.length === 0) {
          if (debugPolling) {
            console.log('⏭️ [notificar] Propostas adicionadas sem id_documento - notificação suprimida:', {
              quantidade_filtrada: propostasAdicionadas.length,
              ids_pedido: propostasAdicionadas.map(p => p.id_pedido)
            })
          }
          return
        }

        const quantidade = propostasComDocumento.length

        let mensagem
        if (quantidade === 1) {
          const proposta = propostasComDocumento[0]
          mensagem = `Nova proposta #${proposta.id_documento} adicionada`
        } else {
          mensagem = `${quantidade} novas propostas adicionadas`
        }

        notification(AlertTypes.SUCCESS, mensagem)

        if (debugPolling) {
          console.log('🔔 [notificar] Propostas adicionadas:', {
            quantidade,
            ids_documento: propostasComDocumento.map(p => p.id_documento)
          })
        }
      },
      notificarPropostasRemovidas (propostasRemovidas) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        // 🔒 FILTRAR: Apenas propostas com id_documento gerado
        // Evita notificações de propostas que ainda não tinham id_documento
        const propostasComDocumento = propostasRemovidas.filter(proposta => {
          return proposta.id_documento != null && proposta.id_documento !== ''
        })

        if (propostasComDocumento.length === 0) {
          if (debugPolling) {
            console.log('⏭️ [notificar] Propostas removidas sem id_documento - notificação suprimida:', {
              quantidade_filtrada: propostasRemovidas.length,
              ids_pedido: propostasRemovidas.map(p => p.id_pedido)
            })
          }
          return
        }

        const quantidade = propostasComDocumento.length

        let mensagem
        if (quantidade === 1) {
          const proposta = propostasComDocumento[0]
          mensagem = `Proposta #${proposta.id_documento} foi removida`
        } else {
          mensagem = `${quantidade} propostas foram removidas`
        }

        notification(AlertTypes.WARNING, mensagem)

        if (debugPolling) {
          console.log('🔔 [notificar] Propostas removidas:', {
            quantidade,
            ids_documento: propostasComDocumento.map(p => p.id_documento)
          })
        }
      },
      processarEventosPropostas (eventos) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        eventos.forEach(evento => {
          // 🔒 FILTRAR: Apenas eventos de propostas com id_documento gerado
          // Evita notificações de eventos quando id_documento ainda não foi gerado
          if (!evento.id_documento || evento.id_documento === '') {
            if (debugPolling) {
              console.log('⏭️ [processarEventos] Evento sem id_documento - notificação suprimida:', {
                tipo: evento.tipo,
                id_pedido: evento.id_pedido
              })
            }
            return
          }

          switch (evento.tipo) {
            case 'contrato_enviado':
              notification(
                AlertTypes.SUCCESS,
                `Contrato da proposta #${evento.id_documento} enviado com sucesso!`
              )
              break

            case 'boleto_gerado':
              notification(
                AlertTypes.SUCCESS,
                `Boleto da proposta #${evento.id_documento} gerado com sucesso!`
              )
              break

            case 'cota_alocada':
              notification(
                AlertTypes.SUCCESS,
                `Cota alocada para proposta #${evento.id_documento}: ${evento.grupo_cota}`
              )
              break

            case 'erro_proposta':
              notification(
                AlertTypes.ERROR,
                evento.mensagem || `Erro na proposta #${evento.id_documento}`
              )
              break

            default:
              if (debugPolling) {
                console.warn('[DetalhesVendaMultipla] Evento desconhecido:', evento.tipo)
              }
          }
        })
      },
      async processarNotificacoesPropostas (notificacoes) {
        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (debugPolling) {
          console.log('📬 [processarNotificacoes] Notificações recebidas:', {
            quantidade: notificacoes.length,
            detalhes: notificacoes.map(n => ({
              id: n.id,
              tipo: n.tipo,
              mensagem: n.mensagem
            }))
          })
        }

        const agrupadas = this.agruparNotificacoesSimilaresPropostas(notificacoes)

        agrupadas.forEach(grupo => {
          let alertType = AlertTypes.INFO

          switch (grupo.tipo) {
            case 'error':
              alertType = AlertTypes.ERROR
              break
            case 'warning':
              alertType = AlertTypes.WARNING
              break
            case 'success':
              alertType = AlertTypes.SUCCESS
              break
          }

          if (grupo.items.length === 1) {
            notification(alertType, grupo.items[0].mensagem)
          } else {
            notification(alertType, grupo.resumo)
          }
        })

        if (debugPolling) {
          console.warn('⚠️ [processarNotificacoesPropostas] Método deprecated - não marcar notificações')
        }
      },
      agruparNotificacoesSimilaresPropostas (notificacoes) {
        if (!notificacoes || notificacoes.length === 0) {
          return []
        }

        const grupos = {}

        notificacoes.forEach(notif => {
          const tipo = notif.tipo || 'info'

          if (!grupos[tipo]) {
            grupos[tipo] = []
          }

          grupos[tipo].push(notif)
        })

        const resultado = []

        Object.keys(grupos).forEach(tipo => {
          const items = grupos[tipo]

          if (items.length === 1) {
            resultado.push({
              tipo,
              items,
              resumo: null
            })
          } else {
            const resumo = `${items.length} notificações sobre propostas`

            resultado.push({
              tipo,
              items,
              resumo
            })
          }
        })

        return resultado
      },
      pararPollingPropostas () {
        if (this.pollingPropostas) {
          this.pollingPropostas.destroy()
          this.pollingPropostas = null
        }
        this.hashPropostas = null

        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'
        if (debugPolling) {
          console.log('🛑 [pararPollingPropostas] Polling parado e recursos liberados')
        }
      },
      handleVisibilityChangePropostas () {
        if (!this.pollingPropostas) {
          return
        }

        const debugPolling = localStorage.getItem('DEBUG_POLLING') === 'true'

        if (document.hidden) {
          if (debugPolling) {
            console.log('[DetalhesVendaMultipla] Página oculta - pausando polling')
          }
          this.pollingPropostas.pause()
        } else {
          if (debugPolling) {
            console.log('[DetalhesVendaMultipla] Página visível - retomando polling')
          }
          this.pollingPropostas.resume(true)
        }
      },
      processarPropostasAtualizadas (propostasAtualizadas) {
        if (this.pausarMonitoramento) return
        propostasAtualizadas.forEach(propostaAtualizada => {
          const indexPropostas = this.propostas.findIndex(p => p.id_pedido === propostaAtualizada.id_pedido)
          const indexMonitoradas = this.propostasMonitoradas.findIndex(p => p.id_pedido === propostaAtualizada.id_pedido)
          if (indexPropostas !== -1) {
            const propostaExistente = this.propostas[indexPropostas]
            const boletoPago = verifyIfPaidAndReturnInBool(propostaAtualizada.status_pedido)
            const propostaAtualizar = {
              ...propostaExistente,
              id_documento: propostaAtualizada.id_documento,
              id_pedido: propostaAtualizada.id_pedido,
              id_carrinho: propostaAtualizada.id_carrinho,
              forma_pagamento: propostaAtualizada.forma_pagamento,
              status_pedido: propostaAtualizada.status_pedido,
              cd_cota: propostaAtualizada.cd_cota,
              cd_grupo: propostaAtualizada.cd_grupo,
              updated_at: propostaAtualizada.updated_at,
              docusign_falha: propostaAtualizada.docusign_falha,
              docusign_enviado: propostaAtualizada.docusign_enviado,
              forma_pagamento_formatada: this.formatFormaPagamento(propostaAtualizada.forma_pagamento),
              status_pedido_desc: StatusPedidoDesc[propostaAtualizada.status_pedido],
              status_boleto: this.getStatusBoleto(
                propostaAtualizada.job_carrinho_boleto_sucesso,
                propostaAtualizada.job_carrinho_boleto_falha,
                propostaAtualizada.job_carrinho_boleto_agendado,
                boletoPago,
                propostaAtualizada.forma_pagamento
              ),
              status_contrato: getDescricaoStatusContrato(
                propostaAtualizada.contrato?.status,
                propostaAtualizada.docusign_falha,
                propostaAtualizada.docusign_enviado
              ),
              grupo_cota: this.formatGroupCota(
                propostaAtualizada.cd_cota,
                propostaAtualizada.cd_grupo,
                propostaAtualizada.status_alocacao?.status_alocacao
              ),
              contrato: propostaAtualizada.contrato ? {
                id_contrato: propostaAtualizada.contrato.id_contrato,
                status: propostaAtualizada.contrato.status,
                updated_at: propostaAtualizada.contrato.updated_at
              } : null
            }
            this.$set(this.propostas, indexPropostas, propostaAtualizar)
            if (indexMonitoradas !== -1) {
              this.$set(this.propostasMonitoradas, indexMonitoradas, { ...propostaAtualizar })
            }
          }
        })
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      }
    }
  }
</script>
<style scoped>
.titulo-boletos-contratos {
    font-size: 1.2rem;
    font-weight: bolder;
    color: var(--primary);
    text-align: center;
}

.text-id-documento {
  text-decoration: underline;
  text-align: left;
  font-size: 1.1rem;
}

.text-id-documento-not-generate {
  text-align: left;
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: normal;
}

.td-item {
    padding: 15px 16px;
    font-weight: bold;
    text-transform: capitalize;
}

.no-padding-left{
  padding-left: 0px;
}

.bordered-cell {
  border-right: 0.5px solid var(--gray);
}
.bordered-cell-left {
  border-left: 0.5px solid var(--gray);
}

.custom-table {
  border-radius: 12px 20px 0px 0px;
  overflow: hidden;
}
.table-container {
  max-height: 60vh;
  display: flex;
  flex-direction: column;
}

.table-container .v-data-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.table-container .v-data-table__wrapper {
  flex: 1;
  overflow-y: auto;
}

.table-container >>> .v-data-table-header {
  position: sticky !important;
  top: 0;
  z-index: 2;
}

.table-container >>> .v-data-table-header tr {
  background-color: var(--primary);
}

.table-container >>> .v-data-footer {
  position: sticky !important;
  bottom: 0;
  z-index: 2;
  padding-right: 17px;
  margin-right: 0px;
  background: white;
}
.custom-table >>> .v-data-table-header th {
  background-color: var(--primary) !important;
  color: white !important;
  font-size: 1.2rem;
  font-weight: 500;
  justify-content: space-between;
}

.custom-table>>>tbody tr:hover {
    background-color: inherit !important;
}

.custom-table >>> .v-data-table-header th .v-icon {
  color: white !important;
}

.actions-background {
    position: relative;
    z-index: 0;
}

.actions-background::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: var(--primary);
    opacity: 0.15;
    z-index: -1;
    pointer-events: none;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
    {
    opacity: 0;
}
.header-line-fixed {
  z-index: 2;
  position: sticky;
  background-color: var(--darkwhite);
  top: -1px;
}

.v-container--max-width{
  max-width: 1366px;
}

</style>
